import React from "react";
import ProductRowLoader from "components/ProductRowLoader";
import classnames from "classnames";

const ProductRowLoaders = ({ count = 0 }) =>
  new Array(count).fill("").map((_, loaderIx) => (
    <div
      key={loaderIx}
      className={classnames("w-100", {
        mt2: loaderIx
      })}
    >
      <ProductRowLoader />
    </div>
  ));

export default ProductRowLoaders;
